module.exports = __webpack_public_path__ + "img/pengumuman.135a307.png";